export default __webpack_public_path__ + "static/media/circus.df7ce03e.png";